import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import {
  UsersThree,
  UserCircle,
  Chair,
  EnvelopeSimple,
  CheckSquare,
} from '@phosphor-icons/react';

function MobileGuestMenu() {
  const navigate = useNavigate();
  
  const guestOptions = [
    {
      title: 'Guest List',
      description: 'Manage your invitees',
      icon: <UsersThree size={32} weight="regular" />,
      path: '/guest-list',
    },
    {
      title: 'Seating Plan',
      description: 'Arrange your tables',
      icon: <Chair size={32} weight="regular" />,
      path: '/seating-plan',
    },
    {
      title: 'Wedding Party',
      description: 'Assign roles for your guests',
      icon: <UserCircle size={32} weight="regular" />,
      path: '/guests/wedding-party',
    },
    {
      title: 'Invitations',
      description: 'Create & send invites',
      icon: <EnvelopeSimple size={32} weight="regular" />,
      path: '/invitation-generator',
    },
    {
      title: 'RSVPs',
      description: 'Track responses',
      icon: <CheckSquare size={32} weight="regular" />,
      path: '/guest-list?tab=rsvp',
    },
  ];

  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Guest Management
      </Typography>
      
      <Grid container spacing={2}>
        {guestOptions.map((option) => (
          <Grid item xs={6} key={option.title}>
            <Paper
              elevation={1}
              sx={{
                p: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: 2,
                transition: 'all 0.2s',
                '&:hover': {
                  bgcolor: 'action.hover',
                  transform: 'translateY(-2px)',
                  boxShadow: 2,
                },
              }}
              onClick={() => navigate(option.path)}
            >
              <Box sx={{ mb: 1, color: 'primary.main' }}>
                {option.icon}
              </Box>
              <Typography variant="subtitle1" fontWeight="medium">
                {option.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {option.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default MobileGuestMenu; 